import { loadStripe } from '@stripe/stripe-js'

export function hasStripePaymentRecovery(error) {
  return Boolean(error?.details?.paymentRecovery?.clientSecret && error?.details?.paymentRecovery?.publishableKey)
}

export async function confirmStripePaymentRecovery(error) {
  const recovery = error?.details?.paymentRecovery

  if (!recovery?.clientSecret || !recovery?.publishableKey) {
    throw error
  }

  const stripe = await loadStripe(recovery.publishableKey)

  if (!stripe) {
    throw new Error('Stripe could not be loaded for payment authentication.')
  }

  const { error: stripeError, paymentIntent } = await stripe.confirmCardPayment(recovery.clientSecret)

  if (stripeError) {
    throw new Error(stripeError.message || 'Stripe authentication failed.')
  }

  if (paymentIntent?.status !== 'succeeded') {
    throw new Error('Payment authentication is not complete yet.')
  }

  return paymentIntent
}
